import { useEffect, useRef, useState } from 'react';

interface DownloadDropdownProps {
  onDownloadExcel: () => void;
  onDownloadJson: () => void;
}

export function DownloadDropdown({
  onDownloadExcel,
  onDownloadJson,
}: DownloadDropdownProps) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleExcelClick = () => {
    onDownloadExcel();
    setDropdownOpen(false);
  };

  const handleJsonClick = () => {
    onDownloadJson();
    setDropdownOpen(false);
  };

  return (
    <div ref={dropdownRef} className="relative">
      <button
        onClick={() => setDropdownOpen(!dropdownOpen)}
        type="button"
        className={`px-3 py-1.5 text-xs border rounded-md cursor-pointer font-medium transition-all duration-150 tracking-button ${
          dropdownOpen
            ? 'border-text-light bg-text-light text-white'
            : 'border-text-light bg-white text-text-light hover:bg-text-light/10'
        }`}
        title="Download options"
      >
        ↓
      </button>
      {dropdownOpen && (
        <div className="absolute top-[calc(100%+0.25rem)] right-0 bg-white border border-border rounded-md shadow-[0_4px_6px_rgba(0,0,0,0.1)] z-[100] min-w-[140px] overflow-hidden">
          <button
            onClick={handleExcelClick}
            type="button"
            className="block w-full px-3.5 py-2.5 text-xs border-none bg-transparent text-text text-left cursor-pointer font-medium transition-colors hover:bg-[rgba(239,235,229,0.5)]"
          >
            Excel (.xlsx)
          </button>
          <button
            onClick={handleJsonClick}
            type="button"
            className="block w-full px-3.5 py-2.5 text-xs border-none bg-transparent text-text text-left cursor-pointer font-medium transition-colors hover:bg-[rgba(239,235,229,0.5)]"
          >
            JSON (.json)
          </button>
        </div>
      )}
    </div>
  );
}
